import {Component, ElementRef, QueryList, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {AuthService} from "../../shared/services/auth.service";
import {AlertService} from "../../shared/services/alert.service";
import {StorageService} from "../../shared/services/storage.service";
import {GlobalService} from "../../shared/services/global.service";
import {Router} from "@angular/router";
import {NavigationLoaderService} from "../../core/navigation/navigation-loader.service";
import {HeaderComponent} from "../../landing/header/header.component";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {SharedModule} from "../../shared/shared.module";
import {NoDataComponent} from "../../layouts/components/no-data/no-data.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSelectModule} from "@angular/material/select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {VexBreadcrumbsComponent} from "@vex/components/vex-breadcrumbs/vex-breadcrumbs.component";
import {VexPageLayoutComponent} from "@vex/components/vex-page-layout/vex-page-layout.component";
import {VexSecondaryToolbarComponent} from "@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component";
import {MatDialog, MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";

@Component({
  selector: 'vex-verify-otp',
  standalone: true,
  imports: [
    HeaderComponent,
    NgIf,
    SharedModule,
    NoDataComponent,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTooltipModule,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    VexBreadcrumbsComponent,
    VexPageLayoutComponent,
    VexSecondaryToolbarComponent,
    MatDialogModule,
    MatCardModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    NgClass
  ],
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.scss'
})
export class VerifyOtpComponent {
  @ViewChildren('inputField') inputFields!: QueryList<ElementRef>;
  @ViewChild('qrModal') qrModal: TemplateRef<any>;
  timeLeft: number = 60
  timerInterval: any
  formattedTime: string = '01:00';
  showResendBtn: boolean = false;
  authData: any;
  qrCode: any;
  showQrImage: any;

  constructor(
    private authService: AuthService,
    private globalService: GlobalService,
    private router: Router,
    protected dialog: MatDialog,
  ) {
    this.authData = StorageService.getItem('auth');
    if (this.authData && this.authData['qr_image']) {
      this.qrCode = this.authData.qr_image
    }
    if(this.authData && this.authData?.show_qr_image){
      this.showQrImage = this.authData['show_qr_image']
    }
    this.startTimer()
  }

  startTimer(): void {
    this.showResendBtn = false;
    this.timeLeft = 60
    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.formattedTime = this.formatTime(this.timeLeft);
      } else {
        this.showResendBtn = true;
        this.clearTimer();
      }
    }, 1000);
  }

  clearTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  ngAfterViewInit() {
    const inputs: any = document.querySelectorAll('.otp-input');
    inputs[0].focus()
    inputs.forEach((input: any, index) => {
      input.addEventListener('input', (event: any) => {
        if (event.inputType === 'insertText' && input.value) {
          const nextInput: any = inputs[index + 1];
          if (nextInput) {
            nextInput.focus();
          }
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Backspace' && !input.value) {
          const previousInput: any = inputs[index - 1];
          if (previousInput) {
            previousInput.focus();
          }
        }
      });
    });
  }

  openQrModal(): void {
    this.dialog.open(this.qrModal, {
      width: '50vw',
      minWidth: '350px'
    });
  }

  closeModal(): void {
    this.dialog.closeAll();
  }

  verify() {
    let otpInput: string = ''
    this.inputFields.forEach(field => {
      otpInput += field.nativeElement.value;
    })
    if (otpInput.length < 6) return
    this.authData = StorageService.getItem('auth')
    let params: any = {
      "unique_id": this.authData.unique_id,
      "secret": this.authData.secret,
      "qr_code": otpInput
    }
    this.authService.verifyOtp(params).subscribe(data => {
      if (data && data.id) {
        this.globalService.setAccessToken(data?.token);
        this.globalService.setSelf({
          'name': data?.name,
          'email': data?.email,
          'contact': data?.contact,
          'user_id': data?.id,
          'username': data?.username,
          'user_type': data?.user_type,
          'image': data?.image
        });
        this.router.navigateByUrl('home');
      }
    }, error => {
      this.inputFields.forEach(field => {
        field.nativeElement.value = '';
      })
      let firstInput: any = document.querySelector('.otp-input')
      firstInput.focus()
    })
  }
}
